import { render, staticRenderFns } from "./VesselInfo.vue?vue&type=template&id=2a1efaf2&scoped=true"
import script from "./VesselInfo.vue?vue&type=script&lang=js"
export * from "./VesselInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1efaf2",
  null
  
)

export default component.exports